import { Reveal, Eyebrow } from "@/components/Reveal";
import { STORE } from "@/lib/catalog";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: `When you send an enquiry or place an order through this website, we collect only what is needed to serve you: your name, mobile number, and optionally your email address, along with the details of the products or message you share with us. We do not collect payment card details, passwords, or any sensitive financial information through this website.`,
  },
  {
    title: "2. How We Use Your Information",
    body: `Your contact details are used solely to respond to your enquiry, confirm product availability and prices, arrange doorstep delivery, and — where you have an ongoing relationship with the store — to manage your khata (monthly account). We do not sell, rent, or share your personal information with any third party for marketing purposes.`,
  },
  {
    title: "3. Communication",
    body: `By submitting an enquiry, you agree that Shivam Kirana Store may contact you on the mobile number or email address you provide, including via phone call, SMS, or WhatsApp, strictly in connection with your enquiry or order. Enquiry notifications are emailed to the store owner at ${STORE.email}.`,
  },
  {
    title: "4. Data Storage & Security",
    body: `Enquiry records are stored securely in our database and are accessible only to the store owner through a password-protected admin area. We retain enquiry records only as long as needed for order fulfilment and reasonable record-keeping.`,
  },
  {
    title: "5. Cookies",
    body: `This website does not use advertising or tracking cookies. A secure session cookie may be used only for the store owner's admin login.`,
  },
  {
    title: "6. Your Rights",
    body: `You may request at any time that we correct or delete the personal information you have shared with us. Simply call us on ${STORE.phoneIntl} or email ${STORE.email} and we will act on your request promptly.`,
  },
  {
    title: "7. Changes to This Policy",
    body: `We may update this Privacy Policy from time to time. The latest version will always be available on this page. Continued use of the website after changes are posted constitutes acceptance of the updated policy.`,
  },
  {
    title: "8. Contact",
    body: `For any privacy-related questions, contact: ${STORE.owner}, Shivam Kirana Store, ${STORE.address}. Phone: ${STORE.phoneIntl}. Email: ${STORE.email}.`,
  },
];

export default function PrivacyPolicy() {
  return (
    <main className="bg-bone min-h-screen" data-testid="privacy-policy-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <Reveal>
          <Eyebrow>Legal</Eyebrow>
          <h1 className="mt-4 font-serif font-bold text-4xl sm:text-5xl tracking-tight text-ink">Privacy Policy</h1>
          <p className="mt-3 text-sm text-ink-muted">Last updated: July 2026 · Shivam Kirana Store, Kanpur</p>
          <p className="mt-6 text-ink-soft leading-relaxed">
            Your trust is the foundation of our store — in person and online. This policy explains,
            in plain language, what we collect and how we treat it.
          </p>
        </Reveal>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.05, 0.3)}>
              <section className="rounded-2xl border border-line bg-white p-6 sm:p-8">
                <h2 className="font-serif font-semibold text-xl text-forest">{s.title}</h2>
                <p className="mt-3 text-sm sm:text-base text-ink-soft leading-relaxed">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
